export { default } from './CompactBriefServices';
